import React from 'react'
import { Box } from '@/components/lib'

import FoodChooser from '../includes/FoodChooser'

export default function Food ({ dataType, value, onChange }) {
  return (
    <Box>
      <FoodChooser
        forId={dataType?._id}
        requiredNutritionFields={dataType?.requiredFoodFields || []}
        value={value}
        onComplete={(foodData) => onChange(foodData)}
      />
    </Box>
  )
}
